/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom} from 'rxjs';

import {ASSET_ERROR} from '../../app/common/constants/resource-constants';
import {ApiConfig} from '../../app/config/api-config';
import {AdnHttpProgressCallback} from './adn-http.service';
import {createAdnUploadFormData} from './adn-http.service';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';

@Injectable({
  providedIn: 'root'
})
export class AdnAssetHelperService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getAsJson(uriParams: any, qStringParams?: any): any {
    return firstValueFrom(this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(uriParams),
      params: _.assign({}, qStringParams, {format: 'json'})
    }));
  }

  fromParentAsJson(path: any, id: any, qStringParams?: any): any {
    return firstValueFrom(this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri([path, id]),
      params: _.assign({}, qStringParams, {format: 'json', concise: true, pageSize: 1000})
    }));
  }

  helpfulUpload(uri: any, parentId: any, data: any, onProgress?: AdnHttpProgressCallback): any {
    return this.theUpload(uri, parentId, data, null, onProgress);
  }

  upload(uri: any, parentId?: any, data?: any, assetId?: any, onProgress?: AdnHttpProgressCallback): any {
    return this.theUpload(uri, parentId, data, assetId, onProgress);
  }

  private theUpload(uri: any, parentId: any, data: any, assetId: any, onProgress?: AdnHttpProgressCallback): any {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    const pathPortions = _.isArray(uri) ? uri.slice() : [uri];
    if (parentId) {
      pathPortions.push(parentId);
    }
    if (assetId) {
      pathPortions.push(assetId);
    }
    if (data.transcodeConfig) {
      data = _.assign({}, data, {transcodeConfig: JSON.stringify(data.transcodeConfig)});
    }
    return firstValueFrom(this.client.upload<any>({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(pathPortions),
      body: createAdnUploadFormData(data)
    }, onProgress)).then((response: any) => {
      if (_.isEmpty(response)) {
        return Promise.reject(ASSET_ERROR.EMPTY_RESPONSE);
      }
      // always return an array so we don't have to muck around with type detection
      return _.isArray(response) ? response : [response];
    });
  }
}
